import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-confirm-threshold-dialog',
  templateUrl: './confirm-threshold-dialog.component.html',
  styleUrls: ['./confirm-threshold-dialog.component.scss']
})
export class ConfirmThresholdDialogComponent implements OnInit {
  form: FormGroup;

  /**
   * highestExceedingValue = la valeur maximale dépassant initialUncoorTHK,
   * transmise via data par la dialog précédente.
   */
  constructor(
      private fb: FormBuilder,
      private dialogRef: MatDialogRef<ConfirmThresholdDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { highestExceedingValue: number }
  ) {
    this.form = this.fb.group({
      newMinimalThk: [
        null,
        [
          Validators.required,
          Validators.min(0),
          this.matchValue(this.data.highestExceedingValue)
        ]
      ]
    });
  }

  ngOnInit(): void {
  }

  /**
   * Validation custom : renvoie une erreur 'mismatch' si la valeur n'est pas égale à expected.
   */
  private matchValue(expected: number): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value == null) return null;
      return +control.value === expected ? null : { mismatch: true };
    };
  }

  onNotYet(): void {
    this.dialogRef.close('NOT_YET');
  }

  onLeaveWithoutSaving(): void {
    this.dialogRef.close('LEAVE');
  }

  onSave(): void {
    if (this.form && this.form.invalid) {
      return;
    }

    this.dialogRef.close('SAVE');
  }
}
